export const getCustomTaskManifest = () => {
  return {
    parameterGroups: [
      {
        label: "Application Configurations",
        parameters: [
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Application",
            parameterKey: "Application",
            keyField: "resourceId",
            parameterValue: "",
            description: "Name of the Application",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Environment",
            parameterKey: "Environment",
            keyField: "resourceId",
            parameterValue: "",
            description: "The type of Env. For Ex- PROD, TEST, STG, NON-PROD",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "String",
            parameterLabel: "ApplicationId",
            parameterKey: "ApplicationId",
            keyField: "resourceId",
            parameterValue: "",
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            hideParameter: true,
          },
        ],
      },
      {
        label: "Instance Configurations",
        parameters: [
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Instance Name",
            parameterKey: "InstanceName",
            keyField: "resourceId",
            parameterValue: "",
            description: "Mention the name for your EC2 Instance",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "Operating System",
            parameterKey: "OperatingSystem",
            keyField: "resourceId",
            parameterValue: "AmazonLinux2",
            description: "Choose an Amazon Machine Image",
            allowedValues: [
              "AmazonLinuxHVM",
              "AmazonLinux2",
              "UbuntuServerHVM",
              "RedHatEnterpriseLinux8",
              "SUSELinuxEnterpriseServer15",
            ],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "VPC",
            initialTemplateType: "VPC",
            parameterLabel: "VPC ID",
            parameterKey: "VPC",
            keyField: "resourceId",
            parameterValue: "",
            description: "The ID of your existing VPC (e.g., vpc-0343606e)",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "Subnet",
            parameterLabel: "Subnet for server",
            parameterKey: "Subnet",
            keyField: "resourceId",
            parameterValue: "",
            initialTemplateType: "Subnet",
            description: "Choose the Subnet to Deploy Instances.",
            isMultiSelect: false,
            isOptional: true,
            minRecordsToBeSelected: "2",
            filterBy: { label: "VPC", value: "VPC" },
          },
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "EC2 Volume Size",
            parameterKey: "EC2VolumeSize",
            keyField: "resourceId",
            parameterValue: "30",
            description: "Size of EC2 volume. Minimum 8 GiB",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "EC2 Volume Type",
            parameterKey: "EC2VolumeType",
            keyField: "resourceId",
            parameterValue: "gp2",
            description:
              "Choose General Purpose SSD(gp2), Provisioned IOPS SSD (io1), Magnetic (standard)",
            allowedValues: ["gp2", "io1", "standard"],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "EBS Optimized",
            parameterKey: "EBSOptimized",
            keyField: "resourceId",
            parameterValue: "false",
            description:
              "Choose whether the instance is optimized for Amazon EBS I/O. Choose only InstanceType that supports this",
            allowedValues: ["true", "false"],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "Block Device DeleteOn Termination",
            parameterKey: "BlockDeviceDeleteOnTermination",
            keyField: "resourceId",
            parameterValue: "true",
            description:
              "When an instance is terminated, Amazon EC2 uses the value of the DeleteOnTermination attribute for each attached EBS volume to determine whether to preserve or delete the volume when the instance is terminated.",
            allowedValues: ["true", "false"],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "SecurityGroup",
            initialTemplateType: "SecurityGroup",
            parameterLabel: "Instance Security Group",
            parameterKey: "SecurityGroup",
            keyField: "resourceId",
            parameterValue: "",
            description: "Select an existing security group.",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "Instance Type",
            parameterKey: "InstanceType",
            keyField: "resourceId",
            parameterValue: "t2.micro",
            description: "Choose an Instance Type.",
            allowedValues: [
              "t2.nano",
              "t2.micro",
              "t2.small",
              "t2.medium",
              "t2.large",
              "m1.small",
              "m1.medium",
              "m1.large",
              "m1.xlarge",
              "m2.xlarge",
              "m2.2xlarge",
              "m2.4xlarge",
              "m3.medium",
              "m3.large",
              "m3.xlarge",
              "m3.2xlarge",
              "m4.large",
              "m4.xlarge",
              "m4.2xlarge",
              "m4.4xlarge",
              "m4.10xlarge",
              "c1.medium",
              "c1.xlarge",
              "c3.large",
              "c3.xlarge",
              "c3.2xlarge",
              "c3.4xlarge",
              "c3.8xlarge",
              "c4.large",
              "c4.xlarge",
              "c4.2xlarge",
              "c4.4xlarge",
              "c4.8xlarge",
              "g2.2xlarge",
              "g2.8xlarge",
              "r3.large",
              "r3.xlarge",
              "r3.2xlarge",
              "r3.4xlarge",
              "r3.8xlarge",
              "i2.xlarge",
              "i2.2xlarge",
              "i2.4xlarge",
              "i2.8xlarge",
              "d2.xlarge",
              "d2.2xlarge",
              "d2.4xlarge",
              "d2.8xlarge",
              "hs1.8xlarge",
              "cr1.8xlarge",
              "cc2.8xlarge",
            ],
            isMultiSelect: false,
            isOptional: false,
          },
        ],
      },
      {
        label: "Optional Parameters",
        parameters: [
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "EC2 Key Pair",
            parameterKey: "EC2KeyPair",
            keyField: "resourceId",
            parameterValue: "",
            description:
              "Mention KeyPair to Assign to EC2 Instances or leave blank",
            isMultiSelect: false,
            isOptional: true,
          },
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Policy Name",
            parameterKey: "PolicyName",
            keyField: "resourceId",
            parameterValue: "",
            description: "Enter the Policy Name.Else leave blank",
            isMultiSelect: false,
            isOptional: true,
          },
        ],
      },
    ],
  };
};
